import _extends from 'babel-runtime/helpers/extends';
import _classCallCheck from 'babel-runtime/helpers/classCallCheck';
import _possibleConstructorReturn from 'babel-runtime/helpers/possibleConstructorReturn';
import _inherits from 'babel-runtime/helpers/inherits';
import React, { PureComponent } from 'react';

/**
 * withPlayerUpdater
 *  provides a UI component with props for the state of media (video, audio).
 *  the wrapped component must have a "mediaPlayer" prop which handles the
 *  registration of media events and provides the mediaPlayer interface.
 */
export var withPlayerUpdater = function withPlayerUpdater(WrappedComponent) {
  var withPlayerUpdaterComponent = function (_PureComponent) {
    _inherits(withPlayerUpdaterComponent, _PureComponent);

    function withPlayerUpdaterComponent(props) {
      _classCallCheck(this, withPlayerUpdaterComponent);

      var _this = _possibleConstructorReturn(this, _PureComponent.call(this, props));

      _this.subscribeToPlayerUpdates = function () {
        _this.unsubscribeFromPlayerUpdates();
        _this.subscriptions.push(_this.props.mediaPlayer.onPlay(_this.handleOnPlay));
        _this.subscriptions.push(_this.props.mediaPlayer.onPause(_this.handleOnPause));
        _this.subscriptions.push(_this.props.mediaPlayer.onEnd(_this.handleOnEnd));
        _this.subscriptions.push(_this.props.mediaPlayer.onTick(_this.handleOnTick));
        _this.subscriptions.push(_this.props.mediaPlayer.onSeekStart(_this.handleOnSeekStart));
        _this.subscriptions.push(_this.props.mediaPlayer.onSeeked(_this.handleOnSeeked));
        _this.subscriptions.push(_this.props.mediaPlayer.onLoaded(_this.handleOnLoaded));
      };

      _this.unsubscribeFromPlayerUpdates = function () {
        var subscription = _this.subscriptions.pop();
        while (subscription) {
          subscription.remove();
          subscription = _this.subscriptions.pop();
        }
      };

      _this.handleOnPlay = function () {
        _this.setState({
          isMediaPlaying: true,
          isMediaSeeking: false,
          mediaDuration: _this.props.mediaPlayer.duration
        });
      };

      _this.handleOnPause = function () {
        _this.setState({
          isMediaPlaying: false,
          isMediaSeeking: false,
          mediaPosition: _this.props.mediaPlayer.position
        });
      };

      _this.handleOnTick = function () {
        _this.setState({
          mediaDuration: _this.props.mediaPlayer.duration,
          mediaPosition: _this.props.mediaPlayer.position
        });
      };

      _this.handleOnSeekStart = function () {
        _this.setState({
          isMediaSeeking: true,
          mediaPosition: _this.props.mediaPlayer.position,
          mediaDuration: _this.props.mediaPlayer.duration
        });
      };

      _this.handleOnSeeked = function () {
        _this.setState({
          isMediaSeeking: false,
          mediaPosition: _this.props.mediaPlayer.position,
          mediaDuration: _this.props.mediaPlayer.duration
        });
      };

      _this.handleOnLoaded = function () {
        _this.setState({
          isMediaLoaded: true,
          mediaPosition: _this.props.mediaPlayer.position,
          mediaDuration: _this.props.mediaPlayer.duration
        });
      };

      _this.handleOnEnd = function () {
        _this.setState({
          isMediaPlaying: false,
          mediaPosition: _this.props.mediaPlayer.position
        });
      };

      _this.state = {
        mediaPosition: 0,
        mediaDuration: 0,
        isMediaLoaded: props.mediaPlayer && props.mediaPlayer.isLoaded,
        isMediaSeeking: false,
        isMediaPlaying: false
      };
      _this.subscriptions = [];
      if (props.mediaPlayer) {
        _this.subscribeToPlayerUpdates();
      }
      return _this;
    }

    withPlayerUpdaterComponent.prototype.componentDidMount = function componentDidMount() {
      if (this.props.mediaPlayer.isLoaded) {
        this.handleOnLoaded();
      }
    };

    withPlayerUpdaterComponent.prototype.componentDidUpdate = function componentDidUpdate(prevProps, prevState, snapshot) {
      if (this.props.mediaPlayer !== prevProps.mediaPlayer) {
        this.unsubscribeFromPlayerUpdates();
        if (this.props.mediaPlayer) {
          this.setState({
            mediaPosition: this.props.mediaPlayer.position,
            mediaDuration: this.props.mediaPlayer.duration,
            isMediaPlaying: this.props.mediaPlayer.isPlaying,
            isMediaSeeking: false,
            isMediaLoaded: this.props.mediaPlayer.isLoaded
          });
          this.subscribeToPlayerUpdates();
        }
      }
    };

    withPlayerUpdaterComponent.prototype.componentWillUnmount = function componentWillUnmount() {
      this.unsubscribeFromPlayerUpdates();
    };

    withPlayerUpdaterComponent.prototype.render = function render() {
      return React.createElement(WrappedComponent, _extends({
        isMediaSeeking: this.state.isMediaSeeking,
        isMediaPlaying: this.state.isMediaPlaying,
        mediaPosition: this.state.mediaPosition,
        mediaDuration: this.state.mediaDuration,
        isMediaLoaded: this.state.isMediaLoaded
      }, this.props));
    };

    return withPlayerUpdaterComponent;
  }(PureComponent);

  return withPlayerUpdaterComponent;
};